export default "__VITE_ASSET__4zT4vVm7__"